import { render, staticRenderFns } from "./Page-1.vue?vue&type=template&id=21d21b08&scoped=true&"
var script = {}
import style0 from "./Page-1.vue?vue&type=style&index=0&id=21d21b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d21b08",
  null
  
)

export default component.exports